import React, {useState, useEffect} from "react";
import Layout from "../Shared/Layout";
import {
    Button, Container, DialogContentText, InputLabel, MenuItem, Select, TextField,
} from "@material-ui/core";
import styled from "styled-components";
import {useForm, usePage} from "@inertiajs/inertia-react";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {Form as FinalForm} from "react-final-form";
import FormControl from "@material-ui/core/FormControl";
import {Trans} from "../utils/i18n";
import {Alert, Snackbar} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import AddressAutocomplete from "../Shared/AddressAutocomplete";
import MuiPhoneNumber from "material-ui-phone-number";
import {useTranslation} from "react-i18next";
import Markdown from 'react-markdown'

const FieldWrapper = styled.div`
    margin-bottom: 10px;
`;

const NiuRepairBoxImg = styled.img`
    width: 140px;
    height: 140px;
    margin: auto;
    object-fit: contain;
`;

const CreateIssueButtonContainer = styled.div`
    flex: 1;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ececec;
    cursor: pointer;
`;

const SelectLabel = styled.div`
    margin-left: 18px;
    margin-top: -8px;
`;
const CreateIssueButton = ({
                               text, ebcParentId, ebcChildId, translationKey, handleDialogOpen, handleClose,
                               help_text = "", help_translationKey = "", help_key = "",
                               handleFaqDialog
                           }) => {
    const openCreateIssueForm = () => {
        handleDialogOpen(ebcParentId, ebcChildId);
    };

    return (<CreateIssueButtonContainer onClick={openCreateIssueForm}>
        <p>
            <span>
                <Trans i18nKey={translationKey}>{text}</Trans>&nbsp;
            </span>
            {help_text !== ""
                ? <span onClick={() => {
                    handleFaqDialog(help_key)
                }}>
                    <Trans i18nKey={help_translationKey}>{help_text}</Trans>
                </span> : ''}
        </p>
        <KeyboardArrowRightIcon/>
    </CreateIssueButtonContainer>);
};

const DisplayFAQInDialog = ({faq, handleFaqDialog, isOpen = false}) => {
    return (<Dialog
        open={isOpen}
        onClose={() => handleFaqDialog(false)}
        fullWidth={true}
        maxWidth={"md"}
    >
        <DialogTitle><Trans>{faq.question}</Trans></DialogTitle>
        <IconButton
            aria-label="close"
            onClick={() => handleFaqDialog(false)}
            sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
            }}
        >
            <CloseIcon/>
        </IconButton>
        <DialogContent>
            <DialogContentText>
                <Markdown>{faq.answer}</Markdown>
            </DialogContentText>
        </DialogContent>
    </Dialog>);
}

const validateEmail = (emailInputText = "") => {
    var mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return !!emailInputText.match(mailFormat);
};

const ContactUsSegway = ({
                             csrf_token,
                             issueTypes,
                             countries,
                             productModels,
                             currentCountry,
                         }) => {
    const {t} = useTranslation();
    const [attachment, setAttachment] = useState("");
    const [errors, setErrors] = useState({
        email: false, confirmEmail: false,
    });

    const [submitting, setSubmitting] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [success, setSuccess] = useState(false);
    const [isFaqDialogOpen, setIsFaqDialogOpen] = useState(false);

    const {data, setData, post, processing, transform} = useForm({
        name: "",
        phoneNumber: "",
        email: "",
        confirmEmail: "",
        issueType: "",
        issueSubType: "",
        summary: "",
        description: "",
        product: "",
        productModel: "",
        productSerialNumber: "",
        housenumber: "",
        street: "",
        city: "",
        zip: "",
        country: "",
    });

    const handleFaqDialog = (key = false) => {
        setIsFaqDialogOpen(key ? faqs[key] : false);
    }

    const handleClose = () => {
        if (!submitting) {
            setIsDialogOpen(false);
        }
    };

    const handleDialogOpen = (ebcParentId, ebcChildId) => {
        setData({
            name: "",
            phoneNumber: "",
            email: "",
            confirmEmail: "",
            issueType: ebcParentId,
            issueSubType: ebcChildId,
            summary: "",
            description: "",
            product: "",
            productModel: "",
            productSerialNumber: "",
            housenumber: "",
            street: "",
            city: "",
            zip: "",
            country: "",
        });

        setAttachment("");
        setErrors({
            email: false, confirmEmail: false, productSerialNumber: false
        });

        setIsDialogOpen(true);
        setSuccess(false);
    };

    const onSubmit = async (addressData) => {
        let postData = Object.assign({}, data, addressData, {
            product: data.product?.value,
        });

        if (!validateEmail(data.email) || !validateEmail(data.confirmEmail) || data.email !== data.confirmEmail || Boolean(errors.productSerialNumber)) {
            return false;
        }

        setSubmitting(true);

        const formData = new FormData();
        Object.keys(postData).map((key) => {
            formData.append(key, postData[key]);
        });

        if (attachment) {
            formData.append("attachment", attachment);
        }

        try {
            const response = await fetch(route("jira.create_issue"), {
                method: "POST", headers: {
                    "X-CSRF-Token": csrf_token,
                }, body: formData,
            });

            const result = await response.json();
            if (result.issueKey) {
                setIsDialogOpen(false);
                setSuccess(true);
                setTimeout(function () {
                    setSuccess(false);
                }, 5000);
            }
            if (result?.status_code === 400 && result?.data?.errorMessage) {
                alert(result?.data?.errorMessage);
            }
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setSubmitting(false);
        }
    };

    useEffect(() => {
        let _errors = {
            email: false, confirmEmail: false, productSerialNumber: false
        };

        if (data.email !== "" && !validateEmail(data.email)) {
            _errors.email = t("contactUs.email.invalid");
        } else if (data.email !== "" && data.confirmEmail !== "" && data.email !== data.confirmEmail) {
            _errors.email = t("contactUs.email.notMatch");
        }

        if (data.confirmEmail !== "" && !validateEmail(data.confirmEmail)) {
            _errors.confirmEmail = t("contactUs.confirmEmail.invalid");
        }

        const productSerialRegex = /^[A-Z0-9]{14}$/;
        if (data.productSerialNumber.trim() === "") {
            _errors.productSerialNumber = t("contactUs.productSerialNumber.empty");
        } else if (data.productSerialNumber.trim() !== "" && !Boolean(data.productSerialNumber.trim().match(productSerialRegex))) {
            _errors.productSerialNumber = t("contactUsSegway.serial.invalid");
        }

        setErrors(_errors);
    }, [data.email, data.confirmEmail, data.productSerialNumber]);

    return (<div className={"-mt-12 bgcolor"}>
        <Snackbar
            open={success}
            autoHideDuration={6000}
            onClose={() => setSuccess(false)}
        >
            <Alert
                icon={<CheckIcon
                    style={{color: "white"}}
                    fontSize="inherit"
                />}
                onClose={() => setSuccess(false)}
                severity="success"
                sx={{width: "100%"}}
                style={{background: "green", color: "white"}}
            >
                <Trans i18nKey={"contactUs.ticketCreatedSuccessfully"}>
                    Your ticket created successfully!
                </Trans>
            </Alert>
        </Snackbar>

        <Container maxWidth="lg">
            <div
                className="max-w-4xl mx-auto flex flex-col items-center mb-16 mt-16 rounded shadow-lg bg-[#fff] p-4">
                <h2 className={"text-center text-2xl font-bold mb-0 mt-8"}>
                    <Trans i18nKey={"contactUs.howCanWeHelpYou"}>
                        How can we help you?
                    </Trans>
                </h2>
                <p className={"text-center text-md font-medium mt-4"}>
                    <Trans i18nKey={"contactUs.selectAnOption"}>
                        Select an option to create a ticket
                    </Trans>
                </p>

                {Object.entries(issueTypes).map(([key, value]) => {
                    return (<div className="w-11/12">
                        <h5 className="text-2xl mb-4">
                            <Trans i18nKey={value.translationKey}>
                                {value.heading}
                            </Trans>
                        </h5>
                        {value?.subTypes.map((issueType) => (<CreateIssueButton
                            key={issueType.id}
                            text={issueType.question}
                            ebcParentId={issueTypes[key].id}
                            ebcChildId={issueType.id}
                            translationKey={issueType.translationKey}
                            handleDialogOpen={handleDialogOpen}
                            handleClose={handleClose}
                            help_text={issueType?.question_help}
                            help_translationKey={issueType?.question_help_translation_key}
                            help_key={issueType?.question_help_key}
                            handleFaqDialog={handleFaqDialog}
                        />))}
                    </div>)
                })}
            </div>
        </Container>

        <DisplayFAQInDialog faq={isFaqDialogOpen} handleFaqDialog={handleFaqDialog} isOpen={isFaqDialogOpen}/>

        <FinalForm onSubmit={onSubmit}>
            {({
                  handleSubmit, values, form, // errors,
                  touched,
              }) => {

                return (<Dialog
                    open={isDialogOpen}
                    onClose={handleClose}
                    fullWidth={true}
                    maxWidth={"md"}
                >
                    <form onSubmit={handleSubmit}>
                        <DialogTitle><Trans
                            i18nKey={"contactUs.createATicket"}
                        >Create a ticket</Trans></DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                <Trans
                                    i18nKey={"contactUs.fillTheFieldsBelow"}
                                >
                                    Fill the fields below and press
                                    submit button.
                                </Trans>
                            </DialogContentText>

                            <FieldWrapper>
                                <TextField
                                    required={true}
                                    id="fullname"
                                    name="fullname"
                                    label={<Trans
                                        i18nKey={"contactUs.fullname"}
                                    >
                                        Full Name
                                    </Trans>}
                                    value={data.name}
                                    onChange={(e) => setData("name", e.target.value || "")}
                                    variant="outlined"
                                    type="text"
                                    disabled={submitting}
                                />
                            </FieldWrapper>

                            <FieldWrapper>
                                <MuiPhoneNumber
                                    variant="outlined"
                                    defaultCountry={currentCountry.toLowerCase()}
                                    required={true}
                                    disabled={submitting}
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    label={<Trans
                                        i18nKey={"contactUs.phoneNumber"}
                                    >
                                        Phone Number
                                    </Trans>}
                                    onChange={(value) => {
                                        value = value.replace(/\+(\d{1,3})\s0(.+)/, "+$1 $2");
                                        setData("phoneNumber", value);
                                    }}
                                    value={data["phoneNumber"]}
                                    sx={{
                                        "& svg": {height: "1em"},
                                    }}
                                />
                            </FieldWrapper>

                            <FieldWrapper className="w-100 flex justify-between">
                                <div style={{width: "49%"}}>
                                    <TextField
                                        required={true}
                                        id="email"
                                        name="email"
                                        label={<Trans
                                            i18nKey={"contactUs.email"}
                                        >
                                            Email
                                        </Trans>}
                                        value={data.email}
                                        onChange={(e) => setData("email", e.target.value || "")}
                                        variant="outlined"
                                        type="email"
                                        disabled={submitting}
                                        error={errors.email}
                                        helperText={errors.email}
                                    />
                                </div>
                                <div style={{width: "49%"}}>
                                    <TextField
                                        required={true}
                                        id="confirm_email"
                                        name="confirm_email"
                                        label={<Trans
                                            i18nKey={"contactUs.confirm_email"}
                                        >
                                            Confirm Email
                                        </Trans>}
                                        value={data.confirmEmail}
                                        onChange={(e) => setData("confirmEmail", e.target.value || "")}
                                        variant="outlined"
                                        type="email"
                                        disabled={submitting}
                                        error={errors.confirmEmail}
                                        helperText={errors.confirmEmail}
                                    />
                                </div>
                            </FieldWrapper>

                            <FieldWrapper className="w-100 flex justify-between">
                                <div style={{width: "49%"}}>
                                    <FormControl fullWidth>
                                        <InputLabel id="label_issue_type">
                                            <SelectLabel>
                                                <Trans
                                                    i18nKey={"contactUs.issueType"}
                                                >
                                                    Issue Type
                                                </Trans>
                                            </SelectLabel>
                                        </InputLabel>
                                        <Select
                                            required={true}
                                            id="issue_type"
                                            labelId="label_issue_type"
                                            label={<Trans
                                                i18nKey={"contactUs.issueType"}
                                            >
                                                Issue Type
                                            </Trans>}
                                            name="issue_type"
                                            value={data.issueType}
                                            onChange={(e) => {
                                                setData("issueType", e.target.value || "");
                                                setData("issueSubType", "");
                                            }}
                                            variant="outlined"
                                            disabled={submitting}
                                        >
                                            {issueTypes.map((value) =>
                                                (<MenuItem value={value.id}>
                                                    <Trans i18nKey={value.translationKey}>
                                                        {value.heading}
                                                    </Trans>
                                                </MenuItem>)
                                            )}
                                        </Select>
                                    </FormControl>
                                </div>

                                <div style={{width: "49%"}}>
                                    <FormControl fullWidth>
                                        <InputLabel id="label_issue_type">
                                            <SelectLabel>
                                                <Trans
                                                    i18nKey={"contactUs.issueSubType"}
                                                >
                                                    Issue Sub-Type
                                                </Trans>
                                            </SelectLabel>
                                        </InputLabel>
                                        <Select
                                            required={true}
                                            id="issue_sub_type"
                                            labelId="label_issue_type"
                                            label={<Trans
                                                i18nKey={"contactUs.issueSubType"}
                                            >
                                                Issue Sub-Type
                                            </Trans>}
                                            name="issue_sub_type"
                                            value={data.issueSubType}
                                            onChange={(e) => setData("issueSubType", e.target.value || "")}
                                            variant="outlined"
                                            disabled={submitting}
                                        >
                                            {issueTypes.map((value) => {
                                                return data.issueType === value.id ? value?.subTypes?.map((issueType, id) => (
                                                    <MenuItem value={issueType.id}>
                                                        <Trans i18nKey={issueType.translationKey}>
                                                            {issueType.question}
                                                        </Trans>
                                                    </MenuItem>)) : null;
                                            })}
                                        </Select>
                                    </FormControl>
                                </div>
                            </FieldWrapper>

                            <FieldWrapper>
                                <TextField
                                    required={true}
                                    id="summary"
                                    name="summary"
                                    label={<Trans
                                        i18nKey={"contactUs.summary"}
                                    >
                                        Summary
                                    </Trans>}
                                    value={data.summary}
                                    onChange={(e) => setData("summary", e.target.value || "")}
                                    variant="outlined"
                                    type="text"
                                    disabled={submitting}
                                />
                            </FieldWrapper>

                            <FieldWrapper>
                                <TextField
                                    required={true}
                                    id="description"
                                    name="description"
                                    label={<Trans
                                        i18nKey={"contactUs.description"}
                                    >
                                        Description
                                    </Trans>}
                                    value={data.description}
                                    onChange={(e) => setData("description", e.target.value || "")}
                                    multiline
                                    minRows={4}
                                    variant="outlined"
                                    type="text"
                                    disabled={submitting}
                                />
                            </FieldWrapper>

                            <FieldWrapper>
                                <FormControl variant="outlined">
                                    <InputLabel id="label_scooter">
                                        <Trans
                                            i18nKey={"contactUs.product"}
                                        >
                                            Product
                                        </Trans>
                                    </InputLabel>

                                    <Select
                                        required={true}
                                        id="niu_scooter"
                                        name="niu_scooter"
                                        labelId="label_scooter"
                                        label={<Trans
                                            i18nKey={"contactUs.product"}
                                        >
                                            Product
                                        </Trans>}
                                        value={data.product}
                                        onChange={(e) => {
                                            setData("product", e.target.value || "");
                                        }}
                                        variant="outlined"
                                        disabled={submitting}
                                    >
                                        {productModels.map((productModel) => (<MenuItem
                                            value={productModel.model}
                                        >
                                            {productModel.model.label}
                                        </MenuItem>))}
                                    </Select>
                                </FormControl>
                            </FieldWrapper>

                            <FieldWrapper>
                                <TextField
                                    required={true}
                                    id="scooter_vin_number"
                                    name="scooter_vin_number"
                                    label={<Trans
                                        i18nKey={"contactUs.productSerialNumber"}
                                    >
                                        Product Serial Number
                                    </Trans>}
                                    value={data.productSerialNumber}
                                    onChange={(e) => setData("productSerialNumber", e.target.value || "")}
                                    variant="outlined"
                                    type="text"
                                    disabled={submitting}
                                    error={Boolean(errors.productSerialNumber)}
                                    helperText={errors.productSerialNumber}
                                />
                            </FieldWrapper>

                            <FieldWrapper>
                                <FormControl variant="outlined">
                                    <InputLabel id="label_country_select">
                                        <Trans
                                            i18nKey={"contactUs.address.country"}
                                        >
                                            Country
                                        </Trans>
                                    </InputLabel>
                                    <Select
                                        name="country"
                                        native
                                        label={<Trans
                                            i18nKey={"contactUs.address.country"}
                                        >
                                            Country
                                        </Trans>}
                                        value={data.country}
                                        disabled={submitting}
                                        required={true}
                                        onChange={(e) => setData("country", e.target.value)}
                                    >
                                        {countries.map((item) => (<option
                                            key={item.code}
                                            value={item.name}
                                        >
                                            {item.name}
                                        </option>))}
                                    </Select>
                                </FormControl>
                            </FieldWrapper>

                            <FieldWrapper>
                                <FormControl fullWidth>
                                    <TextField
                                        variant="outlined"
                                        label={<Trans
                                            i18nKey={"contactUs.attachment"}
                                        >
                                            Attachment
                                        </Trans>}
                                        onChange={(e) => setAttachment(e.target.files[0])}
                                        type="file"
                                        InputLabelProps={{focused: true, shrink: true}}
                                        disabled={submitting}
                                    />
                                </FormControl>
                            </FieldWrapper>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                variant="contained"
                                onClick={handleClose}
                                disabled={submitting}
                            >
                                <Trans i18nKey={"contactUs.cancel"}>
                                    Cancel
                                </Trans>
                            </Button>
                            <Button
                                variant="contained"
                                color={"secondary"}
                                type={"submit"}
                                disabled={submitting}
                            >
                                {submitting ? (<Trans
                                    i18nKey={"contactUs.submitting"}
                                >
                                    Submitting...
                                </Trans>) : (<Trans
                                    i18nKey={"contactUs.submit"}
                                >
                                    Submit
                                </Trans>)}
                            </Button>
                        </DialogActions>
                    </form>
                </Dialog>);
            }}
        </FinalForm>
    </div>)
        ;
};

export default ContactUsSegway;

ContactUsSegway.layout = (page) => <Layout children={page}/>;
